__turbopack_context__.v({
  "link": "_2lhy0W_link",
  "message": "_2lhy0W_message",
  "wrapper": "_2lhy0W_wrapper",
});
